'use strict';

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var bw = require('./bw.js');

var stat = require('../repo/stat.js');

var stat$1 = require('../bitswap/stat.js');

var StatsAPI = function StatsAPI(_ref) {
  var repo = _ref.repo,
      network = _ref.network;

  _classCallCheck(this, StatsAPI);

  this.repo = stat.createStat({
    repo: repo
  });
  this.bw = bw.createBw({
    network: network
  });
  this.bitswap = stat$1.createStat({
    network: network
  });
};

exports.StatsAPI = StatsAPI;